import api from '../../api';

const fetchUserStatistics =(params) => api.get(`/lms/user_statistics`);


export {
    fetchUserStatistics,
};